export default __webpack_public_path__ + "static/media/bareSoilImage.bfa35015.png";